/*=========================================================================================
  File Name: moduleDesignManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/design/pixinvent
==========================================================================================*/


import state from './moduleDesignManagementState.js'
import mutations from './moduleDesignManagementMutations.js'
import actions from './moduleDesignManagementActions.js'
import getters from './moduleDesignManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

